import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography/Typography";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Error from "@material-ui/icons/Error";
import MainButton from "../Shared/Components/MainButton";
import CustomDialog from "../Shared/Components/CustomDialog";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { useDispatch } from "react-redux";
import { resetConfigurationCode } from "../reducers/Configuration/Actions";

const useStyles = makeStyles((theme) => ({
  dialogTitleRoot: {
    padding: "12px 12px 20px",
    fontSize: "1.5rem",
    fontWeight: 400,
  },
  dialogContentRoot: {
    padding: "0 24px 0 12px",
  },
  activeButton: {
    padding: "6px 15px",
  },
  saveConfigurationCode: {
    textAlign: "center",
    marginTop: 24,
    marginBottom: 48,
    height: 40,
    fontSize: 24,
    lineHeight: "28px",
    [theme.breakpoints.down("xs")]: {
      height: 56,
      marginBottom: 32,
    },
  },
  TypographyCaption: {
    fontSize: 12,
    lineHeight: 1.7,
  },
  successResult: {
    background: "#4FC36D",
    color: "#fff",
    padding: "14px 8px",
    borderRadius: "4px",
  },
  successResultIcon: {
    float: "left",
  },
  errorResult: {
    background: "#ED1C29",
    color: "#fff",
    padding: "14px 8px",
    borderRadius: "4px",
    fontSize: 14,
    lineHeight: 1.7,
    textAlign: "center",
    "& p": { color: "#fff !important" },
  },
  errorResultIcon: {
    float: "left",
  },
  dialogSavingInProgress: {
    flex: 1,
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
    height: 50,
    marginTop: 24,
  },
}));

const SaveConfiguration = (props) => {
  const { workInProgress, errorMessage, code, show, onClose, onOkClick, ProgressComponent } = props;
  const classes = useStyles(props);
  const dispatch = useDispatch();
  const { t } = useTranslation(["saveConfiguration", "common"]);

  const close = async () => {
    await onClose();
    // we need to reset the code so a new one is created on next save
    dispatch(resetConfigurationCode());
  };

  const confirm = async () => {
    await onOkClick();
    // we need to reset the code so a new one is created on next save
    dispatch(resetConfigurationCode());
  };

  return (
    <CustomDialog
      open={show}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onCancel={close}
      dialogTitle={t("saveConfiguration")}
    >
      <DialogContent className={classes.dialogContentRoot}>
        {workInProgress && (
          <div className={classes.dialogSavingInProgress}>
            <ProgressComponent />
          </div>
        )}
        {errorMessage && (
          <Typography
            variant="body1"
            classes={{
              root: classes.TypographyCaption,
            }}
            id="alert-dialog-description"
          >
            <div className={classes.errorResult}>
              <Error className={classes.errorResultIcon} />
              {errorMessage}
            </div>
          </Typography>
        )}
        {!workInProgress && code && (
          <React.Fragment>
            <Typography
              variant="body1"
              classes={{ root: classes.TypographyCaption }}
              id="alert-dialog-description"
            >
              {t("saveSuccessfully")}
            </Typography>

            <Typography
              variant="body1"
              classes={{ root: classes.TypographyCaption }}
              id="alert-dialog-description"
            >
              {t("loadWithCodeText")}
            </Typography>
            <Typography
              id="alert-dialog-description"
              variant="h5"
              classes={{ root: classes.saveConfigurationCode }}
            >
              <div className={classes.successResult}>
                <CheckCircle className={classes.successResultIcon} />
                <b>{code}</b>
              </div>
            </Typography>
          </React.Fragment>
        )}
      </DialogContent>
      <DialogActions>
        {!workInProgress && code && (
          <MainButton
            onClick={confirm}
            variant="contained"
            size="medium"
            className={clsx(classes.activeButton, "primaryButton")}
          >
            {t("common:ok")}
          </MainButton>
        )}
      </DialogActions>
    </CustomDialog>
  );
};
SaveConfiguration.propTypes = {
  classes: PropTypes.object,
  workInProgress: PropTypes.bool,
  errorMessage: PropTypes.string,
  code: PropTypes.string,
  loadLoginInfoInProgress: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onOkClick: PropTypes.func,
  ProgressComponent: PropTypes.object,
};
export default SaveConfiguration;
